import { faPenToSquare, faPhone } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'
import { type Control, useFormContext } from 'react-hook-form'
import { TextInput } from '~/components/Form'
import { AddressInput } from '~/components/Form/Input/AddressInput'
import { Label } from '~/components/Form/Input/Label'
import { inputWrapper } from '~/components/Form/Input/TextInput.css'
import {
  Button,
  ButtonVariation
} from '~/components/Global/Interactions/Button'
import { formatAddress } from '~/domains/common/utils'
import { identitySummary, identitySummaryLine } from './ApplicationActions.css'
import type { IntegrationFormValues } from './applicationIntegrationSchema'

export const ApplicationIntegrationIdentityFields = () => {
  const {
    register,
    control: typedControl,
    setValue,
    watch,
    getValues,
    formState
  } = useFormContext<IntegrationFormValues>()
  const control = typedControl as Control<any>

  const [isExpanded, setIsExpanded] = useState(false)

  const sharedProps = { register, control, setValue, watch }

  if (!isExpanded) {
    const values = getValues()
    const fullName = [values.firstname, values.lastname]
      .filter((v) => v && v.trim() !== '')
      .join(' ')
    const address = values.address
    const cityLine = formatAddress(address ?? undefined, {
      showLines: false,
      showCountry: false
    })
    const summaryParts = [fullName, values.phone, cityLine].filter(
      (v) => v && v.trim() !== ''
    )

    return (
      <div className={inputWrapper}>
        <Label>Identité</Label>
        <div className={identitySummary}>
          <div className={identitySummaryLine}>{summaryParts.join(' · ')}</div>
          <Button
            variation={ButtonVariation.Link}
            buttonSize="small"
            onClick={() => setIsExpanded(true)}
          >
            <FontAwesomeIcon icon={faPenToSquare} />
            Modifier
          </Button>
        </div>
      </div>
    )
  }

  return (
    <>
      <TextInput
        label="Nom"
        name="lastname"
        {...sharedProps}
        error={formState.errors.lastname}
      />
      <TextInput
        label="Prénom"
        name="firstname"
        {...sharedProps}
        error={formState.errors.firstname}
      />
      <TextInput
        label="Téléphone"
        name="phone"
        type="tel"
        leadingIcon={faPhone}
        {...sharedProps}
        error={formState.errors.phone}
      />
      <AddressInput
        label="Adresse"
        defaultValue={getValues('address') ?? null}
        onChange={(address) => {
          setValue('address', address, {
            shouldDirty: true,
            shouldValidate: true
          })
        }}
      />
    </>
  )
}
